<template>
  <div>
    <layout menu-item="6">
      <div class="wh100 inner-container" v-if="loaded">
        <select class="form-control mb-2" @change="changeTag($event.target.value)">
          <option v-for="tag in tags" :value="tag">#{{tag}}</option>
        </select>
        <h4>Posts: {{totalPosts}}</h4>
        <pagination from="1" :to="pages" :current="page" @onSelect="getPosts"/>

        <div v-for="post in posts">
          <instagram-post :postData="post" :blocked="post.blocked" @toggle="toggle"/>
        </div>

        <div style="clear: left;">
          <pagination from="1" :to="pages" :current="page" @onSelect="getPosts"/>
        </div>
      </div>
    </layout>
  </div>
</template>

<script>

  import InstagramPost from "./InstagramPost";
  import Backend from '@/Backend';
  import Pagination from "../Pagination";

  export default {
    components: {
      Pagination,
      InstagramPost
    },
    name: "instagram",
    data() {
      return {
        tag: '',
        page: 1,
        tags: [],
        posts: [],
        loaded: false,
        pages: 1,
        totalPosts:0
      }
    },
    mounted() {
      Backend.instance.getTags()
        .then((response) => {
          this.tags = response;
          this.tag = this.tags[0];
          this.getPosts(1);
          this.loaded = true;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    methods: {
      toggle(data) {
        data.blocked = !data.blocked;
        Backend.instance.blockPost(data._id, data.blocked);
      },
      changeTag(tag) {
        this.tag = tag;
        this.page = 1;
        this.getPosts(1);
      },
      getPosts(page) {
        console.log('getPosts', page);
        this.page = page;
        Backend.instance.getPosts(this.tag, page)
          .then((response) => {
            console.log(response);
            this.posts = response.docs;
            this.pages = response.pages;
            this.totalPosts = response.total;
          })
          .catch((e) => {

          });
      },
    }
  }
</script>

<style scoped>
  .container {
    position: relative;

  }

  select {
    max-width: 22rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/instagram/Instagram.vue